import api from "./axios";

export const authApi = {
  register: (payload) => api.post("/register", payload).then((r) => r.data),
  login: (payload) => api.post("/login", payload).then((r) => r.data),
  checkAuth: () => api.get("/check-auth").then((r) => r.data),

  // ─────────── Password reset (4-digit OTP flow) ───────────

  // Step 1 — request a code be emailed to the user
  // backend: POST /reset-password-req  { email }
  forgotPassword: (email) =>
    api.post("/reset-password-req", { email }).then((r) => r.data),

  // Step 2 — verify the code the user typed
  // backend: POST /reset-password-otp-verify  { email, otp }
  verifyResetOtp: (email, otp) =>
    api.post("/reset-password-otp-verify", { email, otp }).then((r) => r.data),

  // Step 3 — set the new password (server re-checks the OTP, then deletes it)
  // backend: POST /reset-password-create  { email, otp, newPassword, confirmPassword }
  resetPassword: ({ email, otp, newPassword, confirmPassword }) =>
    api
      .post("/reset-password-create", {
        email,
        otp,
        newPassword,
        confirmPassword,
      })
      .then((r) => r.data),

  updatePassword: ({ old_password, new_password, confirm_password }) =>
    api
      .post("/update-password", {
        old_password,
        new_password,
        confirm_password,
      })
      .then((r) => r.data),
};
